// extracted by mini-css-extract-plugin
export default {"col_box":"index_col_box_oPGtO","col_navlist":"index_col_navlist_oahVq"};